import React from "react";

const FeaturedGameCard = (props) => {
    return(
        <div className="featured-game-container">
            <div className="featured-game-background">
            </div>
            <div className="featured-game-image" style={{backgroundColor: "rgb(252, 255, 114)"}}>
                {props.image && <img src={props.image}/>}
            </div>
            {props.title !== "Explore Our Games" ? 
            <div className="featured-game-text">
                <h1>{props.title}</h1>
                <h1>{props.description}</h1>
            </div>
            :
            <div className="explore-games-card">
                <div className="explore-games-card-text">
                    <h1>{props.title}<br/>{props.description}</h1>
                </div>
            </div>
            }
        </div>
    );
}

export default FeaturedGameCard;